// "Add applicant" slideover. Opened by the index "Add applicant" button via the
// window event "open-add-applicant-slideover". Creates a Registration (and the
// underlying Person) through POST /applicants, then opens the new record's
// slideover.
const blankForm = () => ({
  first_name: "",
  last_name: "",
  email: "",
  phone: "",
  min_beds: null,
  max_beds: null,
  max_rent: null,
  furnished: "",
  needs_parking: false,
  needs_outside_space: false,
  area_ids: [],
});

export function addApplicantSlideover() {
  return {
    open: false,
    saving: false,
    formErrors: {},
    zIndex: 100010,
    agencyAreas: [],
    areaOpen: false,
    form: blankForm(),
    // Set when a register_applicant doorway card opened this form.
    proposedActionId: null,

    init() {
      try {
        this.agencyAreas = JSON.parse(this.$el.dataset.agencyAreas || "[]");
      } catch (e) {
        this.agencyAreas = [];
      }
      window.addEventListener("open-add-applicant-slideover", (e) => this.openForCreate(e.detail));
    },

    openForCreate(detail = null) {
      const store = Alpine.store?.("slideovers");
      if (store?.getNextZIndex) this.zIndex = store.getNextZIndex();
      this.form = blankForm();
      this.formErrors = {};
      this.saving = false;
      this.proposedActionId = null;

      // A register_applicant doorway card: the form pre-filled from the
      // enquiry Alice read; saving resolves the card.
      if (detail?.prefill) {
        this.proposedActionId = detail.proposed_action_id || null;
        Object.keys(detail.prefill).forEach((key) => {
          if (key in this.form && detail.prefill[key] != null) {
            this.form[key] = detail.prefill[key];
          }
        });
      }

      this.open = true;
    },

    close() {
      this.open = false;
    },

    get headerTitle() {
      const name = [this.form.first_name, this.form.last_name].filter((p) => p && p.trim()).join(" ");
      return name || "New applicant";
    },

    // --- Areas multi-select (shared markup contract) ---
    toggleArea(id) {
      id = Number(id);
      const i = this.form.area_ids.indexOf(id);
      if (i === -1) this.form.area_ids.push(id);
      else this.form.area_ids.splice(i, 1);
    },
    isAreaSelected(id) {
      return this.form.area_ids.includes(Number(id));
    },
    areaName(id) {
      const a = this.agencyAreas.find((x) => x.id === Number(id));
      return a ? a.name : "";
    },

    validate() {
      this.formErrors = {};
      if (!this.form.first_name.trim()) this.formErrors.first_name = "Required";
      if (!this.form.last_name.trim()) this.formErrors.last_name = "Required";
      if (Object.keys(this.formErrors).length) {
        this.formErrors.base = "Please enter the applicant's name.";
        return false;
      }
      return true;
    },

    async createApplicant() {
      if (this.saving || !this.validate()) return;
      this.saving = true;

      try {
        const response = await fetch("/applicants.json", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
          },
          body: JSON.stringify({ applicant: this.form, proposed_action_id: this.proposedActionId || undefined }),
        });
        let data = null;
        try { data = await response.json(); } catch (_) { data = null; }

        if (response.ok && data && data.success) {
          window.dispatchEvent(new CustomEvent("applicant-created", { detail: { applicant: data.applicant } }));
          this.close();
          setTimeout(() => {
            window.dispatchEvent(new CustomEvent("open-applicant-slideover", { detail: { id: data.applicant.id } }));
          }, 300);
        } else if (data && data.errors && typeof data.errors === "object") {
          Object.entries(data.errors).forEach(([field, messages]) => {
            this.formErrors[field] = Array.isArray(messages) ? messages[0] : messages;
          });
          this.formErrors.base = "Please fix the highlighted fields and try again.";
        } else {
          this.formErrors.base = `Couldn't save the applicant (server error ${response.status}). Please try again.`;
        }
      } catch (e) {
        this.formErrors.base = "Couldn't reach the server. Check your connection and try again.";
      } finally {
        this.saving = false;
      }
    },
  };
}
